<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 10:00:47
 * @LastEditors: xgx
 * @LastEditTime: 2023-05-11 10:38:39
-->
<template>
  <div class="content" :style="{height:height}">
    <div class="top">
      <el-select
        v-model="value"
        placeholder="请选择"
        style="width: 220px; margin-right: 20px"
      >
        <el-option
          v-for="item in selectOptions"
          :key="item.id"
          :label="item.name"
          :value="`${item.id}`"
        >
        </el-option>
      </el-select>
       <el-button @click="search" type="primary">查询</el-button>
    </div>
    <div class="data-analysis">
      <div class="total">
        <div class="item">
          <div class="new-users">
            <div class="news-box">
              <div class="user-title">新注册人数</div>
              <div class="user-num">
                <span>{{ resData.newNumber }}</span
                >个
              </div>
            </div>
          </div>
        </div>
        <div class="item" style="margin-left: 20px">
          <div class="cont-user">
            <div class="news-box">
              <div class="user-title">累计注册人数</div>
              <div class="user-num">
                <span>{{ resData.countNumber }}</span
                >个
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="charts">
        <div style="display: flex; align-items: center; font-weight: bold">
          <div class="tab-tips"></div>
          <div>注册用户性别分布</div>
        </div>
        <div class="charts-item">
          <div id="gender-chart" class="gender-chart"></div>
          <div class="data-info">
            <div class="info-item" style="color: #b8b6b6; margin-bottom: 26px">
              <span class="item-one">性别</span>
              <span class="item-one">用户</span>
              <span class="item-one">占比</span>
            </div>
            <div class="info-item">
              <span class="item-one">男</span>
              <span class="item-one">{{ resData.male }}</span>
              <span class="item-one">{{ resData.maleRound }}%</span>
            </div>
            <div class="info-item">
              <span class="item-one">女</span>
              <span class="item-one">{{ resData.girl }}</span>
              <span class="item-one">{{ resData.girlRound }}%</span>
            </div>
          </div>
        </div>
      </div>
      <div class="charts">
        <div style="display: flex; align-items: center; font-weight: bold">
          <div class="tab-tips"></div>
          <div>注册用户年龄分布</div>
        </div>
        <div class="charts-item">
          <div id="age-chart" class="gender-chart"></div>
          <div class="data-info">
            <div class="info-item" style="color: #b8b6b6; margin-bottom: 26px">
              <span class="item-one">年龄</span>
              <span class="item-one">用户数</span>
              <span class="item-one">占比</span>
            </div>
            <div class="info-item">
              <span class="item-one">26岁以下</span>
              <span class="item-one">{{ resData.num }}</span>
              <span class="item-one">{{ resData.numRound }}%</span>
            </div>
            <div class="info-item">
              <span class="item-one">26至35岁</span>
              <span class="item-one">{{ resData.num1 }}</span>
              <span class="item-one">{{ resData.num1Round }}%</span>
            </div>
            <div class="info-item">
              <span class="item-one">36至45岁</span>
              <span class="item-one">{{ resData.num2 }}</span>
              <span class="item-one">{{ resData.num2Round }}%</span>
            </div>
            <div class="info-item">
              <span class="item-one">46至60岁</span>
              <span class="item-one">{{ resData.num3 }}</span>
              <span class="item-one">{{ resData.num3Round }}%</span>
            </div>
            <div class="info-item">
              <span class="item-one">60以上</span>
              <span class="item-one">{{ resData.num4 }}</span>
              <span class="item-one">{{ resData.num4Round }}%</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from "echarts";
import { countUserData, list } from "./user_analysis";
export default {
  data() {
    return {
      selectOptions: [],
      value: `${sessionStorage.getItem("siteId")}`,
      resData: {},
      height:0,
    };
  },
  mounted() {
    this.getUserData();
    this.getList();
      this.height = (document.documentElement.clientHeight - 110)+'px';
    window.onresize = () => {
      return (() => {
         this.height = (document.documentElement.clientHeight - 110)+'px';
      })();
    };
  },
  methods: {
    search() {
      this.getUserData();
    },
    getList() {
      list({}).then((res) => {
        if (res.code == 0) {
          this.selectOptions = res.data;
        }
      });
    },
    getUserData() {
      countUserData({
        id: this.value,
      }).then((res) => {
        if (res.code == 0) {
          this.resData = res.data;
          let option = {
            legend: {
              bottom: 10,
              left: "center",
              data: ["男", "女"],
            },
            series: [
              {
                name: "用户性别分布图",
                type: "pie",
                radius: ["45%", "60%"],
                labelLine: {
                  length: 30,
                },
                color: ["#40a9ff", "#ff7875"],
                label: {
                  formatter: "{b} {d}%",
                },
                data: [
                  {
                    value: res.data.male,
                    name: "男",
                  },
                  {
                    value: res.data.girl,
                    name: "女",
                  },
                ],
              },
            ],
          };
          let option2 = {
            legend: {
              bottom: 0,
              left: "center",
              data: ["26岁以下", "26至35岁", "36至45岁", "46至60岁", "60以上"],
            },
            series: [
              {
                name: "注册用户年龄分布",
                type: "pie",
                radius: ["45%", "60%"],
                labelLine: {
                  length: 30,
                },
                color: ["#68bbc4", "#5087ec", "#f2bd42", "#58a55c", "#ee75af"],
                label: {
                  formatter: "{b} {d}%",
                },
                data: [
                  { value: res.data.num, name: "26岁以下" },
                  { value: res.data.num1, name: "26至35岁" },
                  { value: res.data.num2, name: "36至45岁" },
                  { value: res.data.num3, name: "46至60岁" },
                  { value: res.data.num4, name: "60以上" },
                ],
              },
            ],
          };
          var chartDom = document.getElementById("gender-chart");
          var myChart = echarts.init(chartDom);
          var chartDom2 = document.getElementById("age-chart");
          var myChart2 = echarts.init(chartDom2);
          option && myChart.setOption(option);
          option2 && myChart2.setOption(option2);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  // padding: 20px 30px;
  background: #fff !important;
  overflow-y: auto;
  .top {
    padding: 20px 30px;
    display: flex;
    align-items: center;
    border-bottom: 2px solid #f7f7f7;
  }
  /deep/.el-input__inner {
      background-color: rgba(245, 247, 250, 1);
      height: 40px;
  }
  .data-analysis {
    padding: 20px 30px;
    .total {
      display: flex;
      align-items: center;
      margin-bottom: 30px;
      .item {
        background: #f7f7f7;
        width: 270px;
        height: 76px;
        padding-left: 30px;
        display: flex;
        align-items: center;
        font-size: 12px;
        font-weight: bold;
        span {
          font-size: 20px;
        }
      }
    }
    .charts {
      .tab-tips {
        width: 6px;
        height: 16px;
        background: #1890ff;
        margin-right: 8px;
      }
      .gender-chart {
        width: 468px;
        height: 300px;
      }
      .charts-item {
        border: 1px solid #dbd8d8;
        margin: 18px 0;
        display: flex;
      }
      .data-info {
        flex: 1;
        padding-left: 60px;
        margin: 40px;
        border-left: 1px solid #dbd8d8;
        .info-item {
          display: flex;
          margin: 18px 0;
          .item-one {
            flex: 1;
            text-align: left;
          }
        }
      }
    }
  }
}
.new-users {
  background: url("~@/assets/images/usercont.png");
  width: 100%;
  height: 100%;
  background-position: 100% 100%;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  .news-box {
    width: 116px;
    .user-title {
      color: rgba(96, 98, 102, 1);
    }
  }
}
.cont-user {
  background: url("~@/assets/images/usertoal.png");
  width: 100%;
  height: 100%;
  background-position: 100% 100%;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  .news-box {
    width: 116px;
    .user-title {
      color: rgba(96, 98, 102, 1);
    }
  }
}
.el-button--primary {
  background: #176de6;
}
</style>